import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-31",
  "use": "icon-sheet_icon-31-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-31\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M12 1.905l8.651 4.956a.25.25 0 01.125.216h0v9.846a.25.25 0 01-.125.216h0l-8.526 4.923a.25.25 0 01-.25 0h0l-8.526-4.923a.25.25 0 01-.125-.216h0V7.077a.25.25 0 01.125-.216h0l8.526-4.923A.25.25 0 0112 1.905h0z\" /><path stroke-linecap=\"round\" d=\"M12 12v6M17.319 9L12 12M12 12L6.988 9\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol